module.exports = __webpack_public_path__ + "img/bank-01-NH.2f0a8593.svg";